<div class=" loading" *ngIf="loader">Loading&#8230;</div>
<div class="row no-gutters content_top_margin bot_spa_aft_sect_heading">
    <div class="col-12">
        <span class="sectionHeading_one" role="heading" aria-level="2">{{ 'address.titleTextBox' | translate }}</span>
    </div>
</div>
<ng-container *ngIf="(!isCoapplicantApplied && !isExistingCustomer) || (isCoapplicantApplied && !isExistingCustomer)">
    <div class="row no-gutters bot_spa_aft_sect_heading" *ngIf="isCoapplicantApplied && !areBothCibcCustomer"
        id="applicant">
        <div class="col-12">
            <span class="sectionHeading_two" role="heading" aria-level="3">
                {{
                'information.applicant' | translate
                }}
            </span>
        </div>
    </div>
    <form [formGroup]="addressForm" action="" method="get">
        <div>
            <div class="row no-gutters bot_spa_aft_sect_heading">
                <div class="streetcol col-12 col-md-12 col-lg-8 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label  p-0 m-0">
                        <label for="streetName" id="appStreetname" class="field_lable_bot_margin_unset">{{
                            'address.street' | translate }}
                        </label>
                    </small>

                    <input id="streetName" type="text" (change)="tempAddressSession()" required name="streetName"
                        formControlName="streetName" class="wdd-fl border-cls" autocomplete="address-line1"
                        aria-labelledby="applicant appStreetname" aria-describedby="appStreetErrorMsg invalid"
                        placeholder="Enter a location"
                        [ngClass]="(f.streetName.touched || submitted) && (f.streetName.errors?.required || f.streetName.errors?.invalidStreet||f.streetName.errors?.noMatchFound) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="35">

                    <ng-container *ngIf="f.streetName.errors?.invalidStreet && !f.streetName.errors?.required">
                        <div class="row no-gutters">
                            <div class="col-12" id="appStreetErrorMsg">
                                <small class="d-flex align-items-start mt-1 errorMsg">
                                    <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                    <span class="ml-2">
                                        {{'address.streetValid' | translate}}
                                    </span>
                                </small>
                            </div>
                        </div>
                    </ng-container>
                    <div class="row no-gutters"
                        *ngIf="f.streetName.invalid && (f.streetName.dirty || f.streetName.touched || submitted)">
                        <div class="col-12" id="appStreetErrorMsg">
                            <small class="d-flex align-items-start mt-1 errorMsg">
                                <ng-container *ngIf="f.streetName.errors?.required && !f.streetName.valid ">
                                    <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                    <span class="ml-2">
                                        {{'address.streetValid' | translate}}
                                    </span>
                                </ng-container>
                            </small>
                        </div>
                    </div>
                    <div class="row no-gutters" *ngIf="submitted&&f.streetName.errors?.noMatchFound">
                        <div class="col-12" id="invalid">
                            <small class="d-flex align-items-start mt-1 errorMsg">
                                <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2" >
                                    {{'address.invalidAddress' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="aptcol col-12 col-md-6 col-lg-4 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="address2" id="appadress" class="field_lable_bot_margin_unset">{{ 'address.unit'
                            | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader " (change)="tempAddressSession()"
                        tabindex="0" aria-describedby="appAptErrMsg" id="address2" name="address2"
                        formControlName="apartment" autocomplete="address-line2" aria-labelledby="applicant appadress"
                        [ngClass]="f.apartment.errors?.invalidApartment||apartmentApp ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="4">

                    <!-- && !f.apartment.errors?.required -->
                    <div class="row no-gutters" *ngIf="f.apartment.errors?.invalidApartment||apartmentApp">
                        <div class="col-12" id="appAptErrMsg">
                            <small class="d-flex align-items-start mt-1 errorMsg">
                                <ng-container *ngIf="f.apartment.errors?.invalidApartment ">
                                    <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                    <span class="ml-2">
                                        {{'address.apartmentValid' | translate}}
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="apartmentApp ">
                                    <img src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
                                        {{'address-validation-popup.confirmAddressDataApt' | translate}}
                                    </span>
                                </ng-container>
                            </small>
                        </div>
                    </div>

                </div>
                <div class="citycol col-12 col-md-6 col-lg-4 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="locality" id="applocality" class="field_lable_bot_margin_unset">{{
                            'address.city' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader " (change)="tempAddressSession()"
                        tabindex="0" required id="locality" name="locality" aria-describedby="appCityErrMsg"
                        aria-required="true" formControlName="city" aria-labelledby="applicant applocality"
                        autocomplete="address-level2"
                        [ngClass]="(f.city.touched || submitted) && (f.city.errors?.required || f.city.errors?.invalidCity) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="24">


                    <div class="row no-gutters" *ngIf="f.city.errors?.invalidCity && !f.city.errors?.required">
                        <div class="col-12" id="appCityErrMsg">
                            <small id="testcity" class="d-flex align-items-start mt-1 errorMsg">
                                <img src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
                                    {{'address.cityValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                    <div class="row no-gutters" *ngIf="f.city.invalid && (f.city.dirty || f.city.touched || submitted)">
                        <div class="col-12" id="appCityErrMsg">
                            <small id="testcity" *ngIf="f.city.errors?.required && !f.city.valid "
                                class="d-flex align-items-start mt-1 errorMsg">
                                <img src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
                                    {{'address.cityValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                </div>
                <div class="provincecol col-12 col-md-6 col-lg-4 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="state" id="appstate" class="field_lable_bot_margin_unset">{{ 'address.province'
                            | translate }}
                        </label>
                    </small>
                    <div [ngClass]="isIos ? 'select-wrapper col-12 p-0 m-0':'NotAvailabeDkmk'">
                        <select *ngIf="currentLang == 'en'" class="wdd-fl border-cls" tabindex="0" required id="state"
                            name="state" aria-describedby="appProvErrMsg" (change)="tempAddressSession()"
                            aria-required="true" formControlName="province" aria-labelledby="applicant appstate"
                            [ngClass]="(f.province.touched || submitted) && (f.province.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                            <option value=""></option>
                            <option *ngFor="let province of provinceOptions; let i = index" [value]="province.code">
                                {{province.nameEn}}</option>

                        </select>

                        <select *ngIf="currentLang == 'fr'" class="wdd-fl border-cls" tabindex="0" required id="state"
                            name="state" aria-describedby="appProvErrMsg" aria-required="true"
                            formControlName="province" aria-labelledby="applicant appstate"
                            (change)="tempAddressSession()"
                            [ngClass]="(f.province.touched || submitted) && (f.province.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                            <option value=""></option>
                            <option *ngFor="let province of provinceOptions; let i = index" [value]="province.code">
                                {{province.nameFr}}</option>

                        </select>
                    </div>
                    <div class="row no-gutters"
                        *ngIf="f.province.invalid && (f.province.dirty || f.province.touched || submitted)">
                        <div class="col-12" id="appProvErrMsg">
                            <small id="teststate" *ngIf="f.province.errors?.required && !f.province.valid "
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2">
                                    {{'address.perrormsg' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                </div>
                <div class="postalcodecol col-12 col-md-6 col-lg-4 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="postcode" id="apppostcode" class="field_lable_bot_margin_unset">{{
                            'address.code' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader" tabindex="0" required
                        (change)="tempAddressSession()" id="postcode" name="postcode" maxlength="7"
                        aria-describedby="appPostalErrMsg" aria-required="true" formControlName="postalCode"
                        autocomplete="postal-code" aria-labelledby="applicant apppostcode"
                        [ngClass]="(f.postalCode.touched || submitted) && (f.postalCode.errors?.required || f.postalCode.errors?.pattern) ? 'invalidBorder' : 'nonSelectBorder'">

                    <small id="appPostalErrMsg" *ngIf="f.postalCode.errors?.pattern && !f.postalCode.errors?.required"
                        class="form-text col-xs-12 col-sm-12 p-0 m-0"> <img src="./assets/images/menu_icons/Alert.svg"
                            alt=""> <span class="pt-1">
                            {{'address.postalValid' | translate}}
                        </span>
                    </small>

                    <div class="row no-gutters"
                        *ngIf="f.postalCode.invalid  && (f?.postalCode.dirty || f?.postalCode.touched || submitted)">
                        <div class="col-12" id="appPostalErrMsg">
                            <small id="testpostcode" *ngIf="f.postalCode.errors?.required && !f.postalCode.valid"
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2">
                                    {{'address.postalValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>

</ng-container>
<ng-container *ngIf="(isCoapplicantApplied && isExistingCustomer) || (isCoapplicantApplied && !isExistingCustomer)">
    <div class="row no-gutters align-items-center bot_spa_aft_sect_heading space_between_section_top">
        <div class="col-lg-4 col-6">
            <span id="coapplicant" class="sectionHeading_two" role="heading" aria-level="3">
                {{
                'information.coApplicant' | translate }}
            </span>
        </div>
        <div class="col-lg-4 col-6 d-flex" *ngIf="isCoapplicantApplied && !isExistingCustomer">
            <label class="checkboxAlignment field_lable_bot_margin_unset mr-2">
                <input type="checkbox" [(ngModel)]="checkBoxValue" (ngModelChange)="onCheckBoxIsClicked($event)" aria-labelledby="checklabel"/>
                <span class="checkmark"></span>
            </label>
            <span id="checklabel">{{ 'address.checkBoxContent' | translate }}
            </span>
        </div>
    </div>
    <form [formGroup]="coapplicantAddressForm" action="" method="get">
        <div>
            <div class="row no-gutters bot_spa_aft_sect_heading">
                <div class="streetcol col-12 col-md-12 col-lg-8 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="coApplicantStreetName" id="costreetname" class="field_lable_bot_margin_unset">{{
                            'address.street' | translate }}
                        </label>
                    </small>

                    <input id="coApplicantStreetName" type="text" (change)="coapplicantTempAddressSession()" required
                        name="coApplicantStreetName" formControlName="streetName" class="wdd-fl border-cls"
                        autocomplete="address-line1" aria-labelledby="coapplicant costreetname"
                        placeholder="Enter a location" aria-describedby="coappStreetErrMsg coappInvalid"
                        [ngClass]="(cf.streetName.touched || coSubmitted) && (cf.streetName.errors?.required || cf.streetName.errors?.invalidStreet||cf.streetName.errors?.noMatchFound) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="35">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <small *ngIf="cf.streetName.errors?.invalidStreet && !cf.streetName.errors?.required"
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2" id="coappStreetErrMsg">
                                    {{'address.streetValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                    <div class="row no-gutters"
                        *ngIf="cf.streetName.invalid && (cf.streetName.dirty || cf.streetName.touched || coSubmitted)">
                        <div class="col-12">
                            <small *ngIf="cf.streetName.errors?.required && !cf.streetName.valid"
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2" id="coappStreetErrMsg">
                                    {{'address.streetValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                    <div class="row no-gutters" *ngIf="submitted&&invalidAddresCoapplicants&&!cf.streetName?.errors">
                        <div class="col-12">
                            <small class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2" id="coappInvalid">
                                    {{'address.invalidAddress' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                    <div class="row no-gutters" *ngIf="submitted&&cf.streetName.errors?.noMatchFound">
                        <div class="col-12">
                            <small class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2" id="coappStreetErrMsg">
                                    {{'address.invalidAddress' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                </div>
                <div class="aptcol col-12 col-md-6 col-lg-4 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="coApplicantAddress2" id="coapartment" class="field_lable_bot_margin_unset">{{
                            'address.unit' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader "
                        (change)="coapplicantTempAddressSession()" tabindex="0" aria-describedby="coappAptErrMsg"
                        id="coApplicantAddress2" name="coApplicantAddress2" formControlName="apartment"
                        autocomplete="address-line2" aria-labelledby="coapplicant coapartment"
                        [ngClass]="cf.apartment.errors?.invalidApartment ||apartmentCoapp? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="4">

                    <!-- && !f.apartment.errors?.required -->
                    <div class="row no-gutters">
                        <div class="col-12" id="coappAptErrMsg">
                            <small *ngIf="cf.apartment.errors?.invalidApartment "
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
                                    {{'address.apartmentValid' | translate}}
                                </span>
                            </small>
                            <small *ngIf="apartmentCoapp " class="d-flex align-items-start mt-1 errorMsg">
                                <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2">
                                    {{'address-validation-popup.confirmAddressDataApt' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="citycol col-12 col-md-6 col-lg-4 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="coApplicantLocality" id="cocity" class="field_lable_bot_margin_unset">{{
                            'address.city' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader "
                        (change)="coapplicantTempAddressSession()" tabindex="0" required id="coApplicantLocality"
                        name="coApplicantLocality" aria-describedby="coappCityErrMsg" aria-required="true"
                        formControlName="city" autocomplete="address-level2" aria-labelledby="coapplicant cocity"
                        [ngClass]="(cf.city.touched || submitted) && (cf.city.errors?.required || cf.city.errors?.invalidCity) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="24">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <small *ngIf="cf.city.errors?.invalidCity && !cf.city.errors?.required"
                                class="d-flex align-items-start mt-1 errorMsg">
                                <img src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2" id="coappCityErrMsg">
                                    {{'address.cityValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                    <div class="row no-gutters"
                        *ngIf="cf.city.invalid && (cf.city.dirty || cf.city.touched || coSubmitted)">
                        <div class="col-12" >
                            <small  *ngIf="cf.city.errors?.required && !cf.city.valid "
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2" id="coappCityErrMsg">
                                    {{'address.cityValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                </div>
                <div class="provincecol col-12 col-md-6 col-lg-4 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0 ">
                        <label for="coApplicantState" id="coprovince" class="field_lable_bot_margin_unset">{{
                            'address.province' | translate }}
                        </label>
                    </small>
                    <div [ngClass]="isIos ? 'select-wrapper col-12 p-0 m-0':'NotAvailabeDkmk'">
                        <select *ngIf="currentLang == 'en'" class="wdd-fl border-cls" tabindex="0" required
                            id="coApplicantState" name="coApplicantState" aria-describedby="coappProvErrMsg"
                            (change)="coapplicantTempAddressSession()" aria-required="true"
                            autocomplete="address-level1" formControlName="province"
                            aria-labelledby="coapplicant coprovince"
                            [ngClass]="(cf.province.touched || coSubmitted) && (cf.province.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                            <option value=""></option>
                            <option *ngFor="let province of provinceOptions; let i = index" [value]="province.code">
                                {{province.nameEn}}</option>

                        </select>

                        <select *ngIf="currentLang == 'fr'" class="wdd-fl border-cls" tabindex="0" required
                            id="coApplicantState" name="coApplicantState" aria-required="true"
                            aria-describedby="coappProvErrMsg" autocomplete="address-level1"
                            aria-labelledby="coapplicant coprovince" formControlName="province"
                            (change)="coapplicantTempAddressSession()"
                            [ngClass]="(cf.province.touched || coSubmitted) && (cf.province.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                            <option value=""></option>
                            <option *ngFor="let province of provinceOptions; let i = index" [value]="province.code">
                                {{province.nameFr}}</option>

                        </select>
                    </div>
                    <div class="row no-gutters"
                        *ngIf="cf.province.invalid && (cf.province.dirty || cf.province.touched || coSubmitted)">
                        <div class="col-12" id="coappProvErrMsg">
                            <small *ngIf="cf.province.errors?.required && !cf.province.valid "
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2">
                                    {{'address.perrormsg' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                </div>
                <div class="postalcodecol col-12 col-md-6 col-lg-4 bot_spa_aft_mobile_sec_heading">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="coApplicantPostcode" id="copostcode" class="field_lable_bot_margin_unset">{{
                            'address.code' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader" tabindex="0" required
                        (change)="tempAddressSession()" id="coApplicantPostcode" name="coApplicantPostcode"
                        maxlength="7" aria-describedby="coappPostalErrMsg" aria-required="true"
                        formControlName="postalCode" autocomplete="postal-code" aria-labelledby="coapplicant copostcode"
                        [ngClass]="(cf.postalCode.touched || coSubmitted) && (cf.postalCode.errors?.required || cf.postalCode.errors?.pattern) ? 'invalidBorder' : 'nonSelectBorder'">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <small *ngIf="cf.postalCode.errors?.pattern && !cf.postalCode.errors?.required"
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2" id="coappPostalErrMsg">
                                    {{'address.postalValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                    <div class="row no-gutters"
                        *ngIf="cf.postalCode.invalid  && (cf?.postalCode.dirty || cf?.postalCode.touched || coSubmitted)">
                        <div class="col-12">
                            <small id="testpostcode" *ngIf="cf.postalCode.errors?.required && !cf.postalCode.valid"
                                class="d-flex align-items-start mt-1 errorMsg"> <img
                                    src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2" id="coappPostalErrMsg">
                                    {{'address.postalValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-container>

<div class="row no-gutters top_height_actionButton content_top_mobile_margin">
    <div class="col-12 d-md-block d-flex flex-column-reverse">
        <cancel-button></cancel-button>
        <button type="button" class="common_btn saveNextBtn_features space_between_button"
            (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
    </div>
</div>

<div class="modal fade" style="background-color: rgba(0, 0, 0, 0.5); " id="addressPop" aria-labelledby="popTitle"
    role="dialog" aria-modal="true" tabindex="-1">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content" appTrapFocusDirective>
            <div class="modal-header">
                <h5 class="modal-title sectionHeading_one" id="popTitle" role="heading" aria-level="2">{{
                    'address-validation-popup.popupTitle' | translate}}</h5>
            </div>
            <div class="modal-body">
                <address-validation-popup *ngIf="addressSuggestionResponse"
                    (addressDataEmitter)="receivedAddress($event)" [ecifResponseData]="addressSuggestionResponse"
                    [sameAddressData]="checkBoxValue"></address-validation-popup>
            </div>
        </div>
    </div>
</div>